import { AuthInfo } from '@/amplify/get-auth-info.ts';
import { getApolloClient } from '@/apollo/apollo-client-instance.ts';
import { FlagsQuery, resolveFlagValue } from '@/feature-flags/flag-query.ts';
import { FFOptions } from '@/feature-flags/flags.ts';

export const getFeatureFlags = async (
  flag: FFOptions,
  authInfo: AuthInfo | null,
) => {
  const fallback =
    typeof flag.defaultEnabled === 'function'
      ? flag.defaultEnabled(authInfo)
      : flag.defaultEnabled;

  try {
    const { data } = await getApolloClient().query({
      query: FlagsQuery,
      fetchPolicy: 'network-only',
    });

    return resolveFlagValue(data.flags, flag.name) ?? fallback ?? false;
  } catch {
    return fallback ?? false;
  }
};
